import PropTypes from "prop-types"
import { Pane } from "components/ui"
import pcoUrl from "@planningcenter/url"

const BlankStateCampusCategory = ({
  isOrgAdmin,
  useOrgMissingBlankState,
  useEventMissingBlankState,
  isAdmin
}) => {
  return (
    <Pane.BlankState>
      {useOrgMissingBlankState ? (
        <div>
          You can use categories and campuses to help find signups more easily on Church Center. To
          get started, you can{" "}
          {isAdmin ? (
            <>add a category in Registrations</>
          ) : (
            <>
              ask an Administrator to add a category to your organization&apos;s Registrations
              settings
            </>
          )}{" "}
          or{" "}
          {isOrgAdmin && (
            <>
              add a campus to your organization&apos;s{" "}
              <a href={`${pcoUrl(window.railsEnv)("accounts")}/organization/campuses`}>
                account settings
              </a>
              .
            </>
          )}
          {!isOrgAdmin && (
            <>
              ask an Organization Administrator to add a campus to your organization&apos;s account
              settings.
            </>
          )}
        </div>
      ) : (
        <>
          {useEventMissingBlankState && (
            <>
              You can assign this signup to categories and campuses so people can find it more
              easily on Church Center.
            </>
          )}
        </>
      )}
    </Pane.BlankState>
  )
}

BlankStateCampusCategory.propTypes = {
  isOrgAdmin: PropTypes.bool,
  useOrgMissingBlankState: PropTypes.bool,
  useEventMissingBlankState: PropTypes.bool,
  onIsEditing: PropTypes.func,
  onModalChange: PropTypes.func,
  onModalClose: PropTypes.func,
  isAdmin: PropTypes.bool
}

export default BlankStateCampusCategory
